module.exports = __webpack_public_path__ + "static/media/map13.5108e219.webp";